import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

type Props = React.ComponentProps<typeof Input> & { toggleTestId?: string };

export const PasswordInput = forwardRef<HTMLInputElement, Props>(({ className = "", toggleTestId = "password-toggle-btn", ...props }, ref) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input ref={ref} {...props} type={show ? "text" : "password"} className={`pr-11 ${className}`} />
      <button type="button" onClick={() => setShow((s) => !s)} aria-label={show ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        title={show ? "Masquer" : "Afficher"} data-testid={toggleTestId}
        className="absolute bottom-0 right-0 flex h-full max-h-12 w-11 items-center justify-center text-muted-foreground transition-colors hover:text-foreground">
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";
